import { Grid, GridCol, Modal } from "@mantine/core";
import React, { useState, useEffect, useRef } from "react";
import "./contact.css";
import CustomButton from "../CustomButton";
import contactBanner from "../../assets/contactBanner.png";
import { useForm, Controller } from "react-hook-form";
import Swal from "sweetalert2";
import base_url from "../../api/bootapi";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Phone } from "@mui/icons-material";
import { ReactComponent as CloseIcon } from "../../assets/iconamoon_close.svg";
import { ReactComponent as ModalIcon } from "../../assets/modalLogo.svg";
import { ReactComponent as CircleTickIcon } from "../../assets/circle_tick.svg";
import { useDisclosure } from "@mantine/hooks";
import { useNavigate } from "react-router-dom";

const Contact = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
    watch,
  } = useForm();

  const navigate = useNavigate();

  const postContactRequest = async (data) => {
    const data2 = {
      full_name: data.full_name,
      email: data.email,
      message: data.message,
      from_site: "flyandclaim",
    };
    try {
      await axios
        .post(`${base_url.api1}/tourapp/contact_us`, data2)
        .then(() => {
          document.getElementById("myForm").reset();
          open();
        });
    } catch (error) {
      console.log(error.response?.status);
      // 403 logout ---------------------------------------------------------------------
      // if (error.response?.status === 403) {
      //   axios
      //     .get(`${base_url.api1}/users/logout`)
      //     .then(() => {
      //       console.log("User logged out");
      //       navigate("/login");
      //     })
      //     .catch((logoutError) => {
      //       console.log(logoutError);
      //     });
      // }
    }
  };
  return (
    <div className="container-wrapper">
      <Modal
        opened={opened}
        onClose={close}
        centered
        radius={"xl"}
        size={"lg"}
        withCloseButton={false}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "30px",
            padding: "48px",
          }}
        >
          <CircleTickIcon />
          <h1
            className="header"
            style={{ color: "#314064", textAlign: "center" }}
          >
            Message sent successfully!
          </h1>
          <p
            style={{ textAlign: "center", color: "#222222" }}
            className="sub-header"
          >
            Thank you! Our team has received your message and will respond
            within 24–48 hours.
          </p>
          <CustomButton
            style={{ width: "50%" }}
            btnText={"BACK"}
            flex={1}
            onClick={close}
          />
        </div>
      </Modal>

      <Grid>
        <GridCol span={{ base: 12, lg: 6 }}>
          <div className="contact-left">
            <h3>Have questions? We’re here to help</h3>
            <form id="myForm" onSubmit={handleSubmit(postContactRequest)}>
              <div className="contact-grid-two">
                <div className="input-wrapper">
                  <label>Email</label>
                  <span style={{ color: "#2271B8" }}>
                    claims@flyandclaim.com
                  </span>
                </div>

                <div className="input-wrapper">
                  <label>Phone</label>
                  <span style={{ color: "#2271B8" }}>845-212-0404</span>
                </div>
              </div>

              <div className="contact-grid-two">
                <div className="input-wrapper">
                  <label>Full name</label>
                  <input
                    type="text"
                    placeholder="Enter your name"
                    name="full_name"
                    {...register("full_name", {
                      required: true,
                    })}
                    onKeyDown={(e) => {
                      const key = e.key;

                      // Allow only letters (A–Z, a–z), Backspace, Tab, Arrow keys
                      if (
                        !/^[a-zA-Z]$/.test(key) &&
                        ![
                          "Backspace",
                          "Tab",
                          "ArrowLeft",
                          "ArrowRight",
                        ].includes(key)
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {errors.full_name && (
                    <p className="errormessage">Name is Required</p>
                  )}
                </div>

                <div className="input-wrapper">
                  <label>Email</label>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    name="email"
                    {...register("email", {
                      required: "Email Address is Required",
                      pattern: {
                        value:
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: "Invalid email address",
                      },
                    })}
                    onKeyDown={(e) => {
                      // Block space
                      if (e.key === " ") {
                        e.preventDefault();
                      }

                      const invalidChars = [
                        "!",
                        "#",
                        "$",
                        "%",
                        "^",
                        "&",
                        "*",
                        "(",
                        ")",
                        ",",
                        "=",
                        "{",
                        "}",
                        "[",
                        "]",
                        ";",
                        ":",
                        '"',
                        "'",
                        "<",
                        ">",
                        "`",
                        "~",
                        "\\",
                        "|",
                        "?",
                      ];
                      if (invalidChars.includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {errors.email && (
                    <p className="errormessage">Email is Required</p>
                  )}
                </div>
              </div>

              <div className="input-wrapper">
                <label>Message</label>
                <textarea
                  type="text"
                  placeholder="Type in your message"
                  name="message"
                  {...register("message", {
                    required: true,
                  })}
                />
                {errors.message && (
                  <p className="errormessage">Message is Required</p>
                )}
              </div>

              <CustomButton btnText={"Get in touch"} />
            </form>
          </div>
        </GridCol>
        <GridCol span={{ base: 12, lg: 6 }}>
          <img
            src={contactBanner}
            alt="contact-banner"
            className="contact-banner"
            style={{ width: "100%", height: "100%" }}
          />
        </GridCol>
      </Grid>
    </div>
  );
};

export default Contact;
